//
// skip some sections(pages) of the form
//

var skipSections = (function () {
    'use strict';

    var coBorrowerIncomeSelector = "input[name='skip_co_borrower_income_section']";
    var coborrowerRadioSelector = "input[name^='coborrower_status']";

    var pathSecretFieldSelector = "input[name='path']";

    var pathInputsSelector = "input[name^='path_']";

    function getCurrentPath() {
        var pathInputs = $(`${pathInputsSelector}:checked`);
        var yesCount = 0;

        for (var pathInput of pathInputs.toArray()) {
            if ($(pathInput).val() == "Yes") {
                yesCount++;
            }
        }

        return yesCount == 3 ? "Business" : "Consumer";
    }

    function populatePathField() {
        $(pathSecretFieldSelector).val(getCurrentPath());
        $(pathSecretFieldSelector).change();
    }

    function hideSecretFields() {
        $(pathSecretFieldSelector).parent().hide();
    }

    function init() {
        hideSecretFields();

        $(coBorrowerIncomeSelector).parent().hide();

        // change value of the hidden field so sitefinity rules kick in

        $(pathInputsSelector).on('change', populatePathField);

        $(coborrowerRadioSelector).on('change', function () {
            var radioValue = $(this).val();
            if (radioValue.toLowerCase().includes("yes")) {
                $(coBorrowerIncomeSelector).val("");
            } else if (radioValue.toLowerCase().includes("no")) {
                $(coBorrowerIncomeSelector).val("skip");
            }
            $(coBorrowerIncomeSelector).change();
        });
    }

    if ($(coBorrowerIncomeSelector).length) {
        init();
    }
})();
